export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M11 21H3v-8h8v8Zm10 0h-8v-8h8v8ZM4.5 19.5h5v-5h-5v5Zm10 0h5v-5h-5v5ZM11 11H3V3h8v8Zm10 0h-8V3h8v8ZM4.5 9.5h5v-5h-5v5Zm10 0h5v-5h-5v5Z"/>
</svg>
`;
